enum PlaneusLanguages {
  DE = "de",
  EN = "en",
  ES = "es",
  FR = "fr",
  HU = "hu",
  PT = "pt",
  CZ = "cz",
  SK = "sk",
  SL = "sl",
  IT = "it",
  PL = "pl",
}

enum DateFormats {
  SYSTEM = "system",
  DE = "de",
  EN_US = "en-US",
  EN_GB = "en-GB",
  ES = "es",
  FR = "fr",
  HU = "hu",
  PT = "pt",
  CS_CZ = "cs-CZ",
  SK = "sk",
  SL = "sl",
  IT = "it",
  PL = "pl",
}

export { PlaneusLanguages, DateFormats }
